import { useState, useEffect } from "react";
import newRequest from "../../../../utils/newRequest";
import { useTranslation } from "react-i18next";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import "./Header.css"

const AddHeaders = ({ isVisible, setVisibility, refreshBrandData }) => {

  const [Page, setPage] = useState("");
  const [Pagedropdown, setPagedropdown] = useState([]);

  const [Title_en, setTitle_en] = useState('')
  const [Title_ar, setTitle_ar] = useState("")
  const [Buttonstatus, setButtonstatus] = useState("")
  const [caption_en, setcaption_en] = useState("");
  const [caption_ar, setcaption_ar] = useState('')

  const [Description, setDescription] = useState("");
  const [Description_ar, setDescription_ar] = useState('')

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const { t, i18n } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageshow, setimageshow] = useState("");

  function handleChangeback(e) {
    setSelectedFile(e.target.files[0]);
    setimageshow(e.target.files[0]);
  }
  useEffect(() => {
    const getpagedata = async () => {
      try {
        const response = await newRequest.get("/blogs/pages");
        const nameEnArray = response.data;
        setPagedropdown(nameEnArray);
      } catch (error) {
        console.log(error);
      }
    };

    getpagedata();
  }, []);
  const handleCloseCreatePopup = () => {
    setVisibility(false);
  };

  const handleAddCompany = async () => {
    //  integrate the post api in try catch blcck
    const formData = new FormData();
    formData.append("caption", caption_en);
    formData.append("caption_ar", caption_ar);
    formData.append("title", Title_en);
    formData.append("title_ar", Title_ar);
    formData.append("description", Description);
    formData.append("description_ar", Description_ar);
    formData.append("url", Page);
    formData.append("button", Buttonstatus);
    formData.append("image", imageshow);
    formData.append("status", 1);
    try {
      const response = await newRequest.post("/creatfirst_container", formData);

      setMessage(
        `Header has been added successfully.`
      );
      refreshBrandData();
      handleCloseCreatePopup();
    } catch (error) {
      console.log(error);
      setError(error?.response?.data?.error || "Error");
    }
  };

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  return (
    <div>
      {message && (
        <CustomSnakebar
          message={message}
          severity="success"
          onClose={resetSnakeBarMessages}
        />
      )}
      {error && (
        <CustomSnakebar
          message={error}
          severity="error"
          onClose={resetSnakeBarMessages}
        />
      )}
      {/* create the post api popup */}
      {isVisible && (
        <div className="popup-overlay z-50">
          <div className="popup-container h-auto sm:w-[45%] w-full">
            <div
              className="popup-form w-full"
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <form className="w-full">
                <h2
                  className={`text-secondary font-sans font-semibold text-2xl ${
                    i18n.language === "ar" ? "text-end" : "text-start"
                  }`}
                >
                  {t("Add")} {t("Headers")}
                </h2>
                <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Title_en"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title")} {t("Name[English]")}
                    </label>
                    <input
                      type="text"
                      id="Title_en"
                      value={Title_en}
                      onChange={(e) => setTitle_en(e.target.value)}
                      placeholder={`${t("Enter")}${t("Title")}${t(
                        "Name[English]"
                      )}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Title_ar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title")} {t("Name[Arabic]")}
                    </label>
                    <input
                      type="text"
                      id="Title_ar"
                      value={Title_ar}
                      onChange={(e) => setTitle_ar(e.target.value)}
                      placeholder={`${t("Enter")}${t("Title")}${t(
                        "Name[Arabic]"
                      )}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="status"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description")}
                    </label>
                    <textarea
                      type="text"
                      id="name_ar"
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Description")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Description_ar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description [Arabic]")}
                    </label>
                    <textarea
                      type="text"
                      id="Description_ar"
                      value={Description_ar}
                      onChange={(e) => setDescription_ar(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Description [Arabic]")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="status"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("caption")}
                    </label>
                    <textarea
                      type="text"
                      id="caption_en"
                      value={caption_en}
                      onChange={(e) => setcaption_en(e.target.value)}
                      placeholder={`${t("Enter")} ${t("caption")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="caption_ar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("caption [Arabic]")}
                    </label>
                    <textarea
                      type="text"
                      id="caption_ar"
                      value={caption_ar}
                      onChange={(e) => setcaption_ar(e.target.value)}
                      placeholder={`${t("Enter")} ${t("caption")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="url"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Url")}
                    </label>
                    {/* <input
                      type="text"
                      id="url"
                      value={url}
                      onChange={(e) => seturl(e.target.value)}
                      placeholder={`${t("Enter")} ${t("url")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    /> */}

                    <select
                      id="status"
                      value={Page}
                      onChange={(e) => setPage(e.target.value)}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      <option value="Select">-- {t("Select")} --</option>
                      {Pagedropdown &&
                        Pagedropdown.map((itme, index) => {
                          return (
                            <option key={index} value={itme.slug}>
                              {itme.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Button"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Button")}
                    </label>
                    <input
                      type="text"
                      id="Button"
                      value={Buttonstatus}
                      onChange={(e) => setButtonstatus(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Button text")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="field1"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Image")}
                    </label>
                    <div className="imgesection">
                      <img
                        src={
                          selectedFile
                            ? URL.createObjectURL(selectedFile)
                            : imageshow != null
                            ? imageshow
                            : ""
                        }
                        className="printerpic"
                        style={{
                          width: selectedFile || imageshow ? "200px" : "200px",
                          height: selectedFile || imageshow ? "200px" : "200px",
                        }}
                      />

                      <div className="row " htmlFor="file-inputs">
                        <label
                          htmlFor="file-inputs"
                          className="choosefile bg-secondary hover:bg-primary"
                        >
                          {t("choose file")}
                        </label>
                        <input
                          id="file-inputs"
                          type="file"
                          onChange={handleChangeback}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full flex justify-center items-center gap-8 mt-5">
                  <button
                    type="button"
                    className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                    onClick={handleCloseCreatePopup}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="button"
                    onClick={handleAddCompany}
                    className="px-5 py-2 rounded-sm w-[70%] bg-secondary text-white font-body text-sm ml-2"
                  >
                    {t("Add")} {t("Headers")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddHeaders;
